import { useLightMode } from '@/hooks/useLightMode'

import { Box, tokenPrefix } from '@hivewatch/dark'
import { MapPinIcon, tokenVar } from '@hivewatch/dark'

import { IncidentMapPin } from '@/components/icons'
import { getAdddressOrCoors } from '@/features/global-map'
import { IncidentQueryResult } from '@/graphql/generated/hooks'

import { StaticMapBox } from './StaticMapBox'

interface MarketIncidentMapIProps {
  incident: IncidentQueryResult['data']['incident']
}

export const MarketIncidentMap = ({ incident }: MarketIncidentMapIProps) => {
  const mode = useLightMode()
  const prefix = tokenPrefix(mode)
  return (
    <Box data-testid='incidentsPage_drawer_marketIncidentMap' p='24px' pb='0'>
      <StaticMapBox
        height='180px'
        latitude={incident?.latitude}
        longitude={incident?.longitude}
      >
        <IncidentMapPin className='icon' />
      </StaticMapBox>

      <Box
        color={`${prefix}text.secondary`}
        display='flex'
        flexDirection='row'
        pt='3'
      >
        {/* Design (dark) pins the icon to icon.primary; light.icon.primary is
        white, so light mode falls back to the visible secondary token. */}
        <MapPinIcon
          color={tokenVar(
            mode === 'light'
              ? 'colors.light.icon.secondary'
              : 'colors.icon.primary'
          )}
          size={24}
        />
        <Box
          fontFamily="'Soehne Kraftig', sans-serif"
          fontWeight='medium'
          ml='10px'
        >
          {getAdddressOrCoors(
            incident?.address,
            incident?.latitude,
            incident?.longitude
          )}
        </Box>
      </Box>
    </Box>
  )
}
